<template>
  <sidebar-item-header class="pc-note__notebook-details-header" name="notebookDetails">笔记本详情</sidebar-item-header>
</template>

<script>
// import IconFont from '@/components/icon/Font.vue'
// import IconEllipsisH from '@/components/icon/EllipsisH.vue'
// import IconClock from '@/components/icon/Clock.vue'
import SidebarItemHeader from '@/components/note/sidebar/SidebarItemHeader.vue'

export default {
  components: {
    // IconFont,
    // IconEllipsisH,
    // IconClock
    SidebarItemHeader
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar.note.notebook {
  .pc-note__notebook-details-header {
    top: 8rem;
    bottom: 2.6rem;
  }
}
.pc-note__sidebar.notebook {
  .pc-note__notebook-details-header {
    top: 2.6rem;
    bottom: 2.6rem;
  }
}

</style>
